var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmploymentHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M793 2205 c-368 -123 -642 -405 -747 -769 -170 -584 170 -1216 750 -1396 101 -31 146 -27 192 14 34 32 37 39 37 90 0 75 -30 107 -138 141 -197 64 -372 193 -469 344 -47 75 -32 148 37 171 27 9 41 7 83 -9 106 -42 205 -37 305 17 65 35 131 110 158 180 27 70 30 194 6 260 -70 186 -262 275 -460 210 -77 -25 -107 -20 -140 24 -29 39 -24 83 18 144 105 153 282 280 465 334 81 24 104 40 126 82 44 84 -22 189 -118 187 -18 0 -65 -11 -105 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289 2215 c-60 -32 -81 -104 -49 -169 22 -47 49 -65 130 -86 156 -42 332 -165 440 -308 58 -77 69 -116 46 -160 -30 -57 -69 -65 -169 -31 -164 56 -350 -26 -428 -189 -34 -72 -38 -198 -8 -277 31 -82 121 -173 202 -203 76 -29 177 -29 249 -2 71 27 92 25 130 -9 61 -54 38 -126 -82 -255 -100 -107 -219 -181 -379 -235 -104 -35 -106 -37 -129 -81 -46 -91 10 -190 109 -190 17 0 72 14 122 30 372 125 648 423 748 807 27 104 36 303 19 425 -57 423 -355 780 -767 918 -100 33 -144 37 -184 15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentHero);
export default __webpack_public_path__ + "static/media/employment-hero.e1c757b986ab5592f729e399602e428a.svg";
export { ForwardRef as ReactComponent };